/* Storybook of Us — sample books.
   Renders example books with the real page renderer (ElrBook + ElrAvatar), so
   shoppers see exactly what a finished book looks like. Every sample is fictional
   and labelled as a sample. Markup: <div data-elr-samples data-limit="10"></div> */
(function () {
  var C = {
    porcelain: 'porcelain', light: 'light', medium: 'medium', tan: 'tan', brown: 'brown', deep: 'deep'
  };
  function p(skin, hair, hairColor, outfit, style, extra) {
    var o = { skin: C[skin], hair: hair, hairColor: hairColor, outfit: outfit, style: style };
    for (var k in extra || {}) o[k] = extra[k];
    return o;
  }
  var SAMPLES = [
    { to: 'Mia', from: 'Sam', recipient: 'Partner', occasion: 'Anniversary', cover: 'Rose',
      av: { to: p('light', 'long', 'brown', 'rose', 'dress'), from: p('medium', 'short', 'darkbrown', 'navy', 'shirt') },
      dedication: 'Five years ago you walked into that tiny coffee shop and changed everything. This is our story, so far.',
      answers: {}, art: {}, little: ['The way you hum when you cook', 'You always save me the last bite', 'How you still hold my hand in the car'] },
    { to: 'Mom', from: 'Ella', recipient: 'Mom', occasion: "Mother's Day", cover: 'Sage',
      av: { to: p('tan', 'bob', 'grey', 'sage', 'dress', { glasses: true }), from: p('tan', 'ponytail', 'black', 'mustard', 'dress') },
      dedication: 'For every packed lunch, every late-night phone call and every hug when I needed it most.',
      answers: { place: 'your garden on a sunny Sunday afternoon', together: 'baking your famous lemon cake and eating it warm',
        laugh: 'dance around the kitchen to the radio' }, art: { place: 'plants', together: 'cake' }, little: [] },
    { to: 'Dad', from: 'Leo', recipient: 'Dad', occasion: "Father's Day", cover: 'Midnight',
      av: { to: p('deep', 'buzz', 'black', 'navy', 'shirt', { beard: 'beard' }), from: p('deep', 'afro', 'black', 'sage', 'shirt') },
      dedication: 'Thanks for teaching me to ride a bike, fix a tap and never give up.',
      answers: { begin: 'you teaching me to ride a bike in the park', together: 'fixing things in the garage on Saturday mornings',
        adventure: 'that camping trip where the tent blew away' }, art: { begin: 'bicycle', together: 'workshop', adventure: 'camping' }, little: [] },
    { to: 'Jess', from: 'Priya', recipient: 'Best friend', occasion: 'Birthday', cover: 'Sand',
      av: { to: p('porcelain', 'wavy', 'blonde', 'lilac', 'dress'), from: p('brown', 'curly', 'black', 'cream', 'shirt') },
      dedication: 'Twenty years of friendship and you still laugh at my terrible jokes.',
      answers: { begin: 'we sat next to each other on the first day of school', together: 'movie marathons with far too much popcorn',
        adventure: 'our road trip along the coast in your old car' }, art: { together: 'movienight' }, little: [] },
    { to: 'James', from: 'Olivia', recipient: 'Husband', occasion: 'Wedding', cover: 'Midnight',
      av: { to: p('light', 'short', 'auburn', 'navy', 'shirt', { beard: 'stubble' }), from: p('light', 'bun', 'blonde', 'cream', 'dress') },
      dedication: 'To my husband, on our first anniversary. Here is to a lifetime more.',
      answers: { begin: 'at a friend’s wedding when you asked me to dance', place: 'the lighthouse where you proposed',
        future: 'grow old together and still dance in the kitchen' }, art: { begin: 'music', place: 'lighthouse', future: 'rings' }, little: [] },
    { to: 'Nana', from: 'Ruby', recipient: 'Grandma', occasion: 'Birthday', cover: 'Rose',
      av: { to: p('porcelain', 'bun', 'grey', 'lilac', 'dress', { glasses: true }), from: p('porcelain', 'ponytail', 'auburn', 'rose', 'dress') },
      dedication: 'Happy 80th birthday, Nana. You make every day feel like a holiday.',
      answers: {}, art: {}, little: [] },
    { to: 'Noah', from: 'Mum', recipient: 'Son', occasion: 'Birthday', cover: 'Sage',
      av: { to: p('medium', 'curly', 'brown', 'mustard', 'shirt'), from: p('medium', 'long', 'darkbrown', 'sage', 'dress') },
      dedication: 'For my brave, funny, wonderful boy. Happy 18th.',
      answers: { place: 'the beach where we built sandcastles every summer', together: 'playing board games and arguing about the rules' },
      art: { place: 'beach', together: 'games' }, little: [] },
    { to: 'Chloe', from: 'Emma', recipient: 'Sister', occasion: 'Just because', cover: 'Sand',
      av: { to: p('tan', 'long', 'black', 'rose', 'dress'), from: p('tan', 'bob', 'black', 'sage', 'dress') },
      dedication: 'My first friend, my partner in crime, my sister.',
      answers: { together: 'singing in the car with the windows down', adventure: 'backpacking around Europe with one tiny suitcase' },
      art: { adventure: 'travel' }, little: [] },
    { to: 'Alex', from: 'Jordan', recipient: 'Boyfriend', occasion: "Valentine's Day", cover: 'Rose',
      av: { to: p('brown', 'short', 'black', 'cream', 'shirt', { glasses: true }), from: p('light', 'wavy', 'brown', 'navy', 'shirt', { beard: 'beard' }) },
      dedication: 'Happy Valentine’s Day to my favourite person.',
      answers: { begin: 'at a rainy bus stop when you shared your umbrella', together: 'walking the dog in the park every morning' },
      art: { begin: 'rain', together: 'dog' }, little: [] },
    { to: 'Aisha', from: 'Omar', recipient: 'Wife', occasion: 'Anniversary', cover: 'Sage',
      av: { to: p('brown', 'long', 'black', 'lilac', 'dress'), from: p('brown', 'short', 'black', 'mustard', 'shirt', { beard: 'beard' }) },
      dedication: 'Ten years married, and I would choose you all over again.',
      answers: { place: 'the rooftop restaurant where we had our first date', together: 'cooking big family dinners together' },
      art: { place: 'dinner', together: 'cooking' }, little: [] }
  ];

  function data(s) {
    return { to: s.to, from: s.from, recipient: s.recipient, occasion: s.occasion, cover: s.cover, dedication: s.dedication,
      av: s.av, answers: s.answers, storyArt: s.art, little: s.little, bubbles: {} };
  }
  function esc(t) { return window.ElrBook.esc(t); }

  function viewer() {
    var v = document.getElementById('elr-sv');
    if (v) return v;
    v = document.createElement('div');
    v.id = 'elr-sv'; v.className = 'elr-sv'; v.hidden = true;
    v.setAttribute('role', 'dialog'); v.setAttribute('aria-modal', 'true'); v.setAttribute('aria-label', 'Sample book');
    v.innerHTML = '<div class="elr-sv__box"><div class="elr-sv__head"><p class="elr-sv__title"></p>' +
      '<button type="button" class="elr-sv__x" aria-label="Close">×</button></div>' +
      '<div class="elr-sv__book"></div><div class="elr-sv__nav"><button type="button" class="elr-sv__prev" aria-label="Previous pages">←</button>' +
      '<span class="elr-sv__count"></span><button type="button" class="elr-sv__next" aria-label="Next pages">→</button></div>' +
      '<a class="elr-sv__cta" href="/pages/create">Create your own story →</a></div>';
    document.body.appendChild(v);
    v.addEventListener('click', function (e) { if (e.target === v) close(); });
    v.querySelector('.elr-sv__x').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (v.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') go(1);
      if (e.key === 'ArrowLeft') go(-1);
    });
    v.querySelector('.elr-sv__prev').addEventListener('click', function () { go(-1); });
    v.querySelector('.elr-sv__next').addEventListener('click', function () { go(1); });
    return v;
  }
  var state = { pages: [], views: [], i: 0, back: null };
  function spreads(n) {  // cover and page 1 alone, then pairs: even page left, odd page right
    var out = [[0], [1]];
    for (var k = 2; k < n; k += 2) out.push(k + 1 < n ? [k, k + 1] : [k]);
    return out;
  }
  function draw() {
    var v = viewer(), wide = window.matchMedia('(min-width: 760px)').matches;
    var views = wide ? spreads(state.pages.length) : state.pages.map(function (_, i) { return [i]; });
    state.views = views; state.i = Math.max(0, Math.min(state.i, views.length - 1));
    var cur = views[state.i];
    v.querySelector('.elr-sv__book').innerHTML = cur.map(function (i) { return '<div class="elr-sv__leaf">' + state.pages[i].html + '</div>'; }).join('');
    v.querySelector('.elr-sv__book').classList.toggle('is-single', cur.length === 1);
    Array.prototype.forEach.call(v.querySelectorAll('.elr-sv__book img'), function (im) { im.loading = 'eager'; });
    v.querySelector('.elr-sv__count').textContent = (state.i + 1) + ' / ' + views.length;
    v.querySelector('.elr-sv__prev').disabled = state.i === 0;
    v.querySelector('.elr-sv__next').disabled = state.i === views.length - 1;
  }
  function go(d) { state.i += d; draw(); }
  function open(s, from) {
    var v = viewer();
    state.pages = window.ElrBook.pages(data(s)); state.i = 0; state.back = from;
    v.querySelector('.elr-sv__title').textContent = 'Sample book · For ' + s.to + ', from ' + s.from;
    v.hidden = false; document.documentElement.style.overflow = 'hidden';
    draw(); v.querySelector('.elr-sv__x').focus();
  }
  function close() {
    var v = viewer(); v.hidden = true; document.documentElement.style.overflow = '';
    if (state.back) state.back.focus();
  }

  function render(root) {
    var limit = parseInt(root.getAttribute('data-limit') || '10', 10);
    root.innerHTML = SAMPLES.slice(0, limit).map(function (s, i) {
      return '<button type="button" class="elr-sc" data-i="' + i + '">' +
        '<span class="elr-sc__cover">' + window.ElrBook.pages(data(s))[0].html + '</span>' +
        '<span class="elr-sc__tag">Sample</span>' +
        '<span class="elr-sc__for">For ' + esc(s.to) + '</span>' +
        '<span class="elr-sc__meta">' + esc(s.recipient) + ' · ' + esc(s.occasion) + '</span>' +
        '<span class="elr-sc__open">Flip through →</span></button>';
    }).join('');
    Array.prototype.forEach.call(root.querySelectorAll('.elr-sc'), function (b) {
      b.addEventListener('click', function () { open(SAMPLES[+b.getAttribute('data-i')], b); });
    });
  }
  function init() {
    if (!window.ElrBook || !window.ElrAvatar) return setTimeout(init, 50);
    Array.prototype.forEach.call(document.querySelectorAll('[data-elr-samples]'), render);
    window.addEventListener('resize', function () { if (!viewer().hidden) draw(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
